import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'pr-details-prop-wrapper',
    templateUrl: './details-prop-wrapper.component.html',
    styleUrls: ['./details-prop-wrapper.component.scss']
})
export class DetailsPropWrapperComponent implements OnInit {

    @Input()
    label: string;

    @Input()
    value: string;

    constructor() {
    }

    ngOnInit(): void {
    }

}
